import http from '../plugins/http'
import {TAG} from '../config/config_api_backend'
import stringInject from 'stringinject'
import {ContentType} from '../constants/DoITConstant'

const getAllTag = async (params) => {
    try {
        console.log(params)
        let response = await http.get(TAG.GET_TAG_ALL, {
            params: {...params, 'isOwned': true, 'isShared': true}
        })
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiCreateTag = async (tagInfo) => {
    try {
        let response = await http.put(TAG.PUT_TAG, JSON.stringify(tagInfo), {
            headers: {
                'Content-Type': ContentType.json
            }
        })
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiUpdateTag = async (id, tagInfo) => {
    let url = stringInject(TAG.UPDATE_TAG, {'id': id})
    let formData = new FormData()
    formData.append('description', tagInfo.description)
    formData.append('name', tagInfo.name)
    try {
        let response = await http.post(url, formData,
            {
                'Content-Type': 'multipart/form-data'
            })
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiShareTag = async (id, tagInfo) => {
    let url = stringInject(TAG.SHARE_TAG, {'id': id})
    let response = await http.post(url, JSON.stringify(tagInfo), {
        headers: {
            'Content-Type': 'application/json'
        }
    })
    return response.data
}

const apiUnshareTag = async (id, tagInfo) => {
    let url = stringInject(TAG.DENY_TAG, {'id': id})
    let response = await http.post(url, JSON.stringify(tagInfo), {
        headers: {
            'Content-Type': 'application/json'
        }
    })
    return response.data
}

const getAllTagsByEmail = async (email, params) => {
    try {
        const formData = new FormData()
        formData.append('email', email)

        let response = await http.post(TAG.GET_ALL_TAG_BY_EMAIL,
            formData,
            {'Content-Type': 'multipart/form-data', 'params': params})
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const getTagInfo = async (id) => {
    try {
        let url = stringInject(TAG.GET_TAG_INFO, {'id': id})
        let response = await http.get(url)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

export {
    getAllTag,
    apiCreateTag,
    apiUpdateTag,
    getAllTagsByEmail,
    getTagInfo,
    apiShareTag,
    apiUnshareTag
}
